'use client';

import React from 'react';
import styles from './BlogSection.module.scss';

import { useInView } from 'react-intersection-observer';
import createAnimationArr from '@/src/lib/helpers/createAnimationArr';
import Wrapper from '@/src/components/ui/wrapper/Wrapper';
import Label from "@/src/components/ui/label/Label";
import AdvantageList from "@/src/components/sections/advantageList/AdvantageList";
import {advBlogFull} from "@/src/lib/staticObjects/advInfo";
import NextImage from "@/src/components/ui/nextImage/NextImage";

const heading = 'Blog That Tells and Connects';
const excerpt =
    'Share meaningful stories, showcase brand values, and connect with your audience on a deeper level.';

type BlogItemProps = {
    image: string;
    alt: string;
    title: string;
    desc: string;
};

const blogItems: BlogItemProps[] = [
    {
        image: '/images/themes/stockist/blog/pic-1.webp',
        alt: 'Clean & Organized Layout',
        title: 'Clean & Organized Layout',
        desc: 'Design your blog with a clear layout that enhances readability and keeps visitors engaged from start to finish.',
    },
    {
        image: '/images/themes/stockist/blog/pic-2.webp',
        alt: 'Impactful Content Headers',
        title: 'Impactful Content Headers',
        desc: 'Highlight your blog’s main points with bold, clear headers that keep readers focused and interested.',
    },
];

const BlogItem: React.FC<BlogItemProps> = ({ image, alt, title, desc }) => (
    <div className={styles.blogSection__item}>
        <div className={styles.blogSection__pic}>
            <NextImage
                src={image}
                alt={alt}
                fill
                sizes="(max-width: 480px) 100vw, 50vw"
                loading="lazy"
            />
        </div>
        <h3 className={styles.blogSection__title}>{title}</h3>
        <div className={styles.blogSection__desc}>{desc}</div>
    </div>
);

const BlogSection = () => {

    const { ref: inViewRef2, inView: inView2 } = useInView({
        triggerOnce: true,
        rootMargin: '-250px 0px 0px',
        threshold: 0,
    });

    return (
        <section className={styles.blogSection}>
            <Wrapper>
                <div className={styles.blogSection__main}>
                    <div className={styles.blogSection__heading} ref={inViewRef2}>
                        <Label>Blog</Label>
                        <h2 className={`heading__2 ${styles.heading} ${inView2 && styles.animate__heading}`}>
                            {createAnimationArr(heading, styles.word__wrapper, 0, 0.01)}
                        </h2>
                        <p className={`excerpt ${styles.excerpt} ${inView2 && styles.animate__excerpt}`}>
                            {createAnimationArr(excerpt, styles.word__wrapper, 0.1, 0.01)}
                        </p>
                    </div>

                    <div className={styles.blogSection__grid}>
                        {blogItems.map((item, index) => (
                            <BlogItem key={index} {...item} />
                        ))}
                    </div>
                </div>

                <AdvantageList advList={advBlogFull} middle/>
            </Wrapper>
        </section>
    );
};

export default BlogSection;
